export default __webpack_public_path__ + "icon_query.9b34649980b70e8c39a40d1793e81ad2.png";